var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M432 176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 272H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zM432 368H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16z"}));
}

BurgerMenu.defaultProps = {"fill":"white","viewBox":"0 0 512 512"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
